import { axios } from '@utils';
import { ValidationError } from '@/errors/ValidationError';

export default {
  namespaced: true,
  state: () => ({
    document: {},
    documentData: '',
  }),
  mutations: {
    updateDocument(state, payload) {
      state.document = payload;
    },
  },
  actions: {
    async documentValidator({ commit }, { formData, path, fileName }) {
      const isPdfResponse = (res) =>
        String(res.headers['content-type']).includes('application/pdf');
      const isP7sResponse = (res) =>
        String(res.headers['content-type']).includes('application/pkcs7-signature');

      function bufferToJson(buffer) {
        const encoder = new TextDecoder('utf-8');
        const bytes = new Uint8Array(buffer);

        return JSON.parse(encoder.decode(bytes));
      }

      try {
        const response = await axios({
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'application/json, application/pdf',
          },
          method: 'post',
          url: path,
          data: formData,
          responseType: 'arraybuffer',
        });

        let payload;
        let newFileName;
        let extension = 'pdf';

        if (isPdfResponse(response) || isP7sResponse(response)) {
          if (isP7sResponse(response)) {
            extension = 'p7s';
          }

          if (fileName.endsWith('.pdf')) {
            newFileName = fileName.slice(0, -4);
          }

          payload = {
            data: response.data,
            name: `${newFileName}.${extension}`,
            signed_by_clicksign: true,
          };
        } else {
          payload = bufferToJson(response.data).document;
        }

        commit('updateDocument', payload);

        return payload;
      } catch (error) {
        if (!error.isAxiosError) throw error;

        const errorsJson = bufferToJson(error.response.data);

        throw new ValidationError(errorsJson.errors[0], { cause: errorsJson });
      }
    },
  },
  getters: {
    validDocument(state) {
      return state.document;
    },
  },
};
